import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './language/index'
import Vant, { Locale } from 'vant'
import 'vant/lib/index.css'

import '@/styles/index.scss' // global css
import 'animate.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

import zhCN from 'vant/lib/locale/lang/zh-CN'
import enUS from 'vant/lib/locale/lang/en-US'
import jaJP from 'vant/lib/locale/lang/ja-JP'

import { Notify } from 'vant'
Vue.prototype.$notify = Notify

Vue.use(Vant)

Vue.use(ElementUI, {
  fallbackLocale: 'en-US',
  i18n: (key, value) => i18n.t(key, value)
})

const lang = i18n.locale

if (lang === 'en-US') {
  Locale.use('en-US', enUS)
} else if (lang === 'ja-JP') {
  Locale.use('ja-JP', jaJP)
} else {
  Locale.use('zh-CN', zhCN)
}
Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
